import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-dark" }
const _hoisted_5 = { class: "col-lg-6 text-right" }
const _hoisted_6 = {
  key: 0,
  class: "container"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-6 col-md-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-lg-4 col-lg-4" }
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormEditor = _resolveComponent("FormEditor")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_Editor = _resolveComponent("Editor")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FormEditor, {
      viewModel: _ctx.formEditor,
      onSaveForm: _ctx.handleCreateFormCommand
    }, null, 8 /* PROPS */, ["viewModel", "onSaveForm"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", null, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", {
                class: "fa fa-angle-double-left",
                "aria-hidden": "true"
              }, null, -1 /* CACHED */),
              _createTextVNode(" Back to pages ", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, _ctx.url_RequestPagesPage]
            ])
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Edit request page", -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-success",
            style: {"padding":"0.7em 2em"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleUpdateRequestPageCommand && _ctx.handleUpdateRequestPageCommand(...args)))
          }, "Save changes")
        ])
      ])
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
    (_ctx.rm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rm.Name) = $event)),
              class: "form-control"
            }, null, 512 /* NEED_PATCH */), [
              [
                _vModelText,
                _ctx.rm.Name,
                void 0,
                { trim: true }
              ]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("small", null, "Name of the page.", -1 /* CACHED */))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Logo url:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rm.LogoUrl) = $event)),
              class: "form-control"
            }, null, 512 /* NEED_PATCH */), [
              [
                _vModelText,
                _ctx.rm.LogoUrl,
                void 0,
                { trim: true }
              ]
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("small", null, "Enter url of your logo. Logo will be displayed on your project request page. By default - TransparentChoice's logo.", -1 /* CACHED */))
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("label", null, "Form:", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rm.FormId) = $event)),
                  class: "form-control"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rm.Forms, (f) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: f.Id
                    }, _toDisplayString(f.Name), 9 /* TEXT, PROPS */, _hoisted_12))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.rm.FormId]
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("small", null, "Choose a form that will be used to collect requests.", -1 /* CACHED */))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showFormCreator && _ctx.showFormCreator(...args))),
                class: "btn btn-outline-secondary"
              }, "New form"),
              (_ctx.rm.FormId)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    target: "_blank",
                    class: "btn btn-outline-secondary",
                    href: _ctx.url_EditFormPage(_ctx.rm.FormId)
                  }, "Edit form", 8 /* PROPS */, _hoisted_14))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("hr", { style: {"margin":"1em 0"} }, null, -1 /* CACHED */)),
          _cache[14] || (_cache[14] = _createElementVNode("h4", null, "Content:", -1 /* CACHED */)),
          _createElementVNode("div", null, [
            _createVNode(_component_Editor, {
              tools: _ctx.tools,
              ref: "editor",
              "content-style": { height: '490px',},
              "default-content": _ctx.rm.ContentHtml
            }, null, 8 /* PROPS */, ["tools", "default-content"])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}